<div>
  <div *ngIf="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
  </div>
  <mat-tab-group animationDuration="0ms" #tabGroup (selectedTabChange)="tabChanged($event)" [selectedIndex]="0">

    <mat-tab label="Default share settings" class="shareSettingsForPass">

      <div *ngIf="!loading" class="msTeam-modalBodyScroll">
        <mat-card class="mat-card">
          <span tabindex="0" aria-label="My file share settings" class="mat-card-label">My file share settings</span><br />
          <section>
            <form *ngIf="accessibleMyfiles" [formGroup]="accessibleByFg">
              <mat-form-field class="mat-form-field-settings">
                <mat-label class="secondary-color">Accessible by</mat-label>
                <mat-select placeholder="Accessible by" formControlName="accessibleByFc"
                            (selectionChange)="onAccessibleChange($event)">
                  <mat-option *ngFor="let access of accessibleMyfiles" [value]="access" class="share-option">
                    {{access.displayname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </section>
          <mat-form-field *ngIf="accessibleindexMyfiles==3" class="mat-form-field-settings anyone-sharepassword" >
            <mat-label class="secondary-color">Share link password</mat-label>
              
            <input matInput [formControl]="passwordFc" [(ngModel)]="password" required [type]="hidemysite ? 'password' : 'text'">
            <!-- <img src="./assets/{{getPasswordIconMySite()}}_password_icon.svg" width="24" height="24" alt="file" class="float-right" (click)="hidemysite = !hidemysite"> -->
            <div *ngIf="hidemysite" class="eyehideIcon" alt="eyehideIcon"  (click)="hidemysite = !hidemysite"></div>
            <div *ngIf="!hidemysite" class="eyeshowIcon" alt="eyeshowIcon"  (click)="hidemysite = !hidemysite"></div>

            <mat-placeholder class="placeholder">Min 5 characters</mat-placeholder>
            <mat-error *ngIf="passwordFc.invalid">{{getErrorMessage(passwordFc)}}</mat-error>
          </mat-form-field>
          <app-passoword-strength-bar *ngIf="accessibleindexMyfiles==3" [passwordToCheck]="password" [barLabel]="barLabel">  </app-passoword-strength-bar> 
          <section>
            <form *ngIf="downloadrightsMyfiles" [formGroup]="downloadRightsFg">
              <mat-form-field class="mat-form-field-settings">
                <mat-label class="secondary-color">Download rights</mat-label>
                <mat-select placeholder="Download rights" formControlName="downloadRightsFc"
                            (selectionChange)="onDownloadChange($event)">
                  <mat-option *ngFor="let download of downloadrightsMyfiles" [value]="download" class="share-option">
                    {{download.displayname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </section>
          <section *ngIf="downloadindexMyfiles==1">
            <!-- <mat-slide-toggle class="mat-slide-toggle-settings" color="primary" [(ngModel)]="isWaterMark" [checked]="isWaterMark">
              Apply watermark
            </mat-slide-toggle> -->
            <div class="toggleContainer">
              <div class="q">Apply watermark</div>
              <input class="primary-color" aria-label="Apply watermark" type="checkbox" [checked]="isWaterMark" name="isWaterMark" id="isWaterMark" [(ngModel)]="isWaterMark">
              <label for="isWaterMark" data-on="Yes" data-off="No" class="primary-color"></label>
            </div>
          </section>
          <section *ngIf="downloadindexMyfiles==2">
            <!-- <mat-slide-toggle class="mat-slide-toggle-settings" color="primary" [(ngModel)]="isApproveVersions"
                              [checked]="isApproveVersions">
              Approve new versions
            </mat-slide-toggle> -->
            <div class="toggleContainer">
              <div class="q">Approve new versions</div>
              <input aria-label="Approve new versions" type="checkbox" (keyup.enter)="onToggleApproveVersion($event)" [checked]="isApproveVersions" name="isApproveVersions" id="isApproveVersions" [(ngModel)]="isApproveVersions">
              <label for="isApproveVersions" data-on="Yes" data-off="No" class="primary-color"></label>
            </div>
          </section>
        </mat-card>
        <mat-card class="mat-card">
          <span tabindex="0" aria-label="Site share settings" class="mat-card-label">Site share settings</span><br />
          <section>
            <form *ngIf="accessibleOtherfiles" [formGroup]="accessibleByFgOther">
              <mat-form-field class="mat-form-field-settings">
                <mat-label class="secondary-color">Accessible by</mat-label>
                <mat-select placeholder="Accessible by" formControlName="accessibleByFcOther"
                            (selectionChange)="onAccessibleChangeOther($event)">
                  <mat-option *ngFor="let access of accessibleOtherfiles" [value]="access" class="share-option">
                    {{access.displayname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </section>
          <mat-form-field *ngIf="accessibleindexOtherfiles==3" class="mat-form-field-settings anyone-sharepassword">
            <mat-label class="secondary-color">Share link password</mat-label>
            <!-- <input matInput [formControl]="passwordFcOther" [(ngModel)]="passwordOther" required> -->
            <input matInput [formControl]="passwordFcOther" [(ngModel)]="passwordOther" required [type]="hideothersite ? 'password' : 'text'">
            <!-- <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> -->
            <!-- <img src="./assets/{{getPasswordIconOtherSite()}}_password_icon.svg" width="24" height="24" alt="file" class="float-right" (click)="hideothersite = !hideothersite"> -->

            <div *ngIf="hideothersite" class="eyehideIcon" alt="eyehideIcon"  (click)="hideothersite = !hideothersite"></div>
            <div *ngIf="!hideothersite" class="eyeshowIcon" alt="eyeshowIcon"  (click)="hideothersite = !hideothersite"></div>
      
            <mat-placeholder class="placeholder">Min 8 characters</mat-placeholder>
            <mat-error *ngIf="passwordFcOther.invalid">{{getErrorMessage(passwordFcOther)}}</mat-error>
          </mat-form-field>
          <app-passoword-strength-bar *ngIf="accessibleindexOtherfiles==3" [passwordToCheck]="passwordOther" [barLabel]="barLabel">  </app-passoword-strength-bar> 
          <section>
            <form *ngIf="downloadrightsOtherfiles" [formGroup]="downloadRightsFgOther">
              <mat-form-field class="mat-form-field-settings">
                <mat-label class="secondary-color">Download rights</mat-label>
                <mat-select placeholder="Download rights" formControlName="downloadRightsFcOther"
                            (selectionChange)="onDownloadChangeOther($event)">
                  <mat-option *ngFor="let download of downloadrightsOtherfiles" [value]="download" class="share-option">
                    {{download.displayname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </section>
          <section *ngIf="downloadindexOtherfiles==1">
            <!-- <mat-slide-toggle class="mat-slide-toggle-settings" color="primary" [(ngModel)]="isWaterMarkOther"
                              [checked]="isWaterMarkOther">
              Apply watermark
            </mat-slide-toggle> -->
            <div class="toggleContainer">
              <div class="q">Apply watermark</div>
              <input aria-label="Apply watermark" type="checkbox" [checked]="isWaterMarkOther" name="isWaterMarkOther" id="isWaterMarkOther" [(ngModel)]="isWaterMarkOther">
              <label for="isWaterMarkOther" data-on="Yes" data-off="No" class="primary-color"></label>
            </div>
          </section>
          <section *ngIf="downloadindexOtherfiles==2">
            <!-- <mat-slide-toggle class="mat-slide-toggle-settings" color="primary" [(ngModel)]="isApproveVersionsOther"
                              [checked]="isApproveVersionsOther">
              Approve new versions
            </mat-slide-toggle> -->
            <div class="toggleContainer">
              <div class="q">Approve new versions</div>
              <input aria-label="Approve new versions" type="checkbox" [checked]="isApproveVersionsOther" name="isApproveVersionsOther" id="isApproveVersionsOther" [(ngModel)]="isApproveVersionsOther">
              <label for="isApproveVersionsOther" data-on="Yes" data-off="No" class="primary-color"></label>
            </div>
          </section>
        </mat-card>
        <mat-card class="mat-card">
          <section>
            <form *ngIf="linkexpires" [formGroup]="linkExpiresFg">
              <mat-form-field class="mat-form-field-settings">
                <mat-label class="secondary-color">Link expires</mat-label>
                <mat-select placeholder="Link expires" formControlName="linkExpiresFc"
                            (selectionChange)="onLinkChange($event)">
                  <mat-option *ngFor="let linkexpire of linkexpires;let i = index;" [value]="linkexpire" class="share-option">
                    <span *ngIf="i==0">{{linkexpire.displayname}}</span>
                    <span *ngIf="i!=0">After {{linkexpire.displayname}} days</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </section>
          <section>
            <!-- <mat-slide-toggle class="mat-slide-toggle-settings" color="primary" [(ngModel)]="notifyEditdownload"
                              [checked]="notifyEditdownload">
              Notify me by email when recipients edit, download, view or print
            </mat-slide-toggle> -->
            <div class="toggleContainer">
              <div class="q">Notify me by email when recipients edit, download, view or print</div>
              <input aria-label="Notify me by email when recipients edit, download, view or print" type="checkbox" [checked]="notifyEditdownload" name="notifyEditdownload" id="notifyEditdownload" [(ngModel)]="notifyEditdownload">
              <label for="notifyEditdownload" data-on="Yes" data-off="No" class="primary-color"></label>
            </div>
          </section>
          <section>
            <!-- <mat-slide-toggle class="mat-slide-toggle-settings add-Margin-Top-TenPx" color="primary" [(ngModel)]="showdialog" [checked]="showdialog">
              Show dialog when sharing
            </mat-slide-toggle> -->
            <div class="toggleContainer">
              <div class="q" style="margin-top: 10px;">Show dialog when sharing</div>
              <input aria-label="Show dialog when sharing" type="checkbox" [checked]="showdialog" name="showdialog" id="showdialog" [(ngModel)]="showdialog">
              <label for="showdialog" data-on="Yes" data-off="No" class="primary-color"></label>
            </div>
          </section>
        </mat-card>
      </div>
      <div class="global-footer" *ngIf="!loading" style="margin-top: 12px;">
        <div class="error-msg" style="margin-left: 20px; margin-right: 26px;" [innerHTML]="errorMsg" *ngIf="errorMsg.length >0 && !loading"></div>

      <div class="msTeam-modal-footer-right" style="margin-right:18px;" *ngIf="!loading">
      <!--   <button mat-raised-button style="margin-right:10px;" (keyup.enter)="closeDialog()" (click)="closeDialog()">Cancel</button>
       -->  <button mat-raised-button style="margin-right:10px;"  type="button" (keyup.enter)="closeDialog()" (click)="closeDialog()" class="cancelBtn">Cancel</button>
        <button id="share_btn" type="submit" class="msTeam-btn" style="margin-right: -3px;" mat-raised-button color="#6264a7" [disabled]="(accessibleindexMyfiles==3&&passwordFc.invalid) || (accessibleindexOtherfiles==3&&passwordFcOther.invalid)" (keyup.enter)="save()" (click)="save()">Save</button>
     </div>
     </div>
    </mat-tab>
    <mat-tab label="Account information">
      <div *ngIf="!loading" class="msTeam-modalBodyScroll">
      <form (ngSubmit)="logout()">
        <mat-card class="mat-card mat-card-account-info">
          <div>
            <mat-form-field class="mat-form-field-settings remove-NegativeMargin-Bottom-SevenPx no-line">
              <input matInput [readonly]="true" [(ngModel)]="username" name="username" />
              <mat-placeholder class="secondary-color">User name</mat-placeholder>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="mat-form-field-settings remove-NegativeMargin-Bottom-SevenPx no-line">
              <input matInput [readonly]="true" [(ngModel)]="useremail" name="useremail" />
              <mat-placeholder class="secondary-color">User email</mat-placeholder>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="mat-form-field-settings remove-NegativeMargin-Bottom-SevenPx no-line">
              <input matInput [readonly]="true" [(ngModel)]="instancename" name="instancename" />
              <mat-placeholder class="secondary-color">Instance name</mat-placeholder>
            </mat-form-field>
          </div>
        </mat-card>
        <div class="global-footer">
          <div class="error-msg" style="margin-left: 20px; margin-right: 20px;" [innerHTML]="errorMsg" *ngIf="errorMsg.length >0 && !loading"></div>
          <div class="msTeam-modal-footer-right" *ngIf="!loading" style="margin-right: 9px;">
            <button mat-raised-button style="margin-right:10px;" type="button" (keyup.enter)="closeDialog()" (click)="closeDialog()" class="cancelBtn">Cancel</button>
            <button id="logout_btn" type="submit" class="msTeam-btn" mat-raised-button color="#6264a7" (keyup.enter)="logout()" (click)="logout()">Logout</button>
          </div>
        </div>
        <div id="divLogin" class="flexContainerSettings">
          <div class="fixedBott">
            <div class="KnowledgeContainertop">
              {{HighQDemoText}}<a id="getHighQDemo" aria-label="HighQ Demo" href="{{HighQDemoLink}}" target="_blank">{{HighQDemoLinkText}}</a>{{HighQDemoTextEnd}}
            </div>
            <div class="KnowledgeContainer">
              {{LoginKBNoteText}}<a id="getKCHelp" aria-label="Knowledge base" href="{{KnowledgebaseLink}}" target="_blank">{{LoginKBNoteLinkText}}</a>
            </div>
          </div>
        </div>
      </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
